import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DISPLAY_HEADER_ICON_BACK,
  DISPLAY_PAGE_CHOOSE_OCCURRENCETIMING
} from "../../constants/common_constants";
import { GeneralCommonHeader } from "../common/GeneralCommonHeader";
import { OccurrenceTimingNextPageButton } from "../../features/components/select_occurrence_timing/ui_elements/OccurrenceTimingNextPageButton";
import { calcUtcDatetime } from "../../utils/basis_util";
import { useTranslation } from "react-i18next";
import {
  useErrorDialog,
  useInitUsageLog,
  useSession,
} from "../../hooks";

export const SelectOccurrenceTiming = () => {

  // ページ遷移用
  const navigate = useNavigate();
  // 言語切替用
  const { t } = useTranslation();
  // セッション情報チェック
  const { handleCheckSession } = useSession("navigateToTopPage");

  const timingList = [
    { id: 1,timing: "キーオン"},
    { id: 2,timing: "クランキング中"},
    { id: 3,timing: "運転中"},
  ]

  const userId =
    localStorage.getItem(
      `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.LastAuthUser`
    ) || "";
  const displayPage = DISPLAY_PAGE_CHOOSE_OCCURRENCETIMING;
  const displayDateTime = calcUtcDatetime(); //現在日時(UTC時刻)

  // 初期表示時の利用ログ登録
  const {handleInit: initUsageLog } = useInitUsageLog({
    userId,
    displayPage,
    displayDateTime,   
  });
  // エラーダイアログ
  const {showErrorDialog } = useErrorDialog();  

  // 選択された発生タイミングを格納
  const [selectedOccurrenceTiming, setSelectedOccurrenceTiming] = useState<number[]>([]);

  const handleClick = (id: number) => {
    setSelectedOccurrenceTiming([id]);
  };
  
  useEffect(() => {
    handleCheckSession();
    // 利用ログ登録
    initUsageLog();
    const handleStorageChange = (event: StorageEvent) => {
      if (
        event.key ===
        `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.LastAuthUser`
      ) {
        const authUser = localStorage.getItem(
          `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.LastAuthUser`
        );
        if (!authUser) {
          console.log(`[${displayPage}]err: userId is unknown`);
          showErrorDialog(
            t("共通エラーポップ.エラー"),
            t("共通エラーポップ.通信エラーが発生しました。"),
            "navigateToTopPage"
          ); //エラー", "通信エラーが発生しました。(トップページに遷移する)
        }
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    // スクロール不可に設定
    <div className="flex flex-col h-svh overflow-hidden">
      {/* header */}
      <GeneralCommonHeader
        title={t("発生タイミング選択画面.発生タイミング選択")} // 発生タイミング選択
        displayheaderIcon={DISPLAY_HEADER_ICON_BACK}
        onBtnClick={() => {
          navigate(-1);
        }}
      />
      {/* header以下 */}
      <div className="flex flex-col m-4 h-full overflow-hidden">
        {/* 選択指示 */}
        <div className="mb-10">
          <p className="pb-2">
            {t("発生タイミング選択画面.不具合の発生タイミングを選択してください")}
          </p>
        </div>

        {/* 発生タイミング選択 */}
        <dl className="h-full overflow-y-scroll overflow-x-hidden">
          {timingList.map(({ id, timing }) => {
            const isSelected = selectedOccurrenceTiming.includes(id);
            return (
              <div 
                key={id}
                className="bg-white rounded border border-gray-700 mb-6">
              <div
                className={`flex items-center ${
                  isSelected && "bg-sub-orange"
                }`}
                onClick={() => handleClick(id)}
                aria-pressed={isSelected}
                role="button"
              >
                <div className="flex items-center cursor-pointer py-2 px-3">
                  {t(`発生タイミング選択画面.${timing}`)}
                </div>
              </div>
              </div>
            );
          })}
        </dl>
        {/* ボタン */}
        <OccurrenceTimingNextPageButton
          disabled={selectedOccurrenceTiming.length === 0}
          occurrenceTiming={selectedOccurrenceTiming[0] ?? null}
        />
      </div>
    </div>
  );
};
